import { render, staticRenderFns } from "./tePayment.vue?vue&type=template&id=83df4660&scoped=true&"
import script from "./tePayment.vue?vue&type=script&lang=js&"
export * from "./tePayment.vue?vue&type=script&lang=js&"
import style0 from "./tePayment.vue?vue&type=style&index=0&id=83df4660&prod&lang=scss&scoped=true&"
import style1 from "./tePayment.vue?vue&type=style&index=1&id=83df4660&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83df4660",
  null
  
)

export default component.exports